import { OverlayMiddleware, SearchHistoryMiddleware } from "../middlewares";

import EmptyState from "./emptyState";
import { GlobalActionCreators } from "../action-creators";
import SagaManager from "../sagas";
import createSagaMiddleware from "redux-saga";
import rootReducer from "../reducers";
import { configureStore } from "@reduxjs/toolkit";
import dynamicMiddlewares from "redux-dynamic-middlewares";
export const storeInit = () => {
  let state = EmptyState;
  let serverState = window.__UAA_STATE__;

  const SagaMiddleware = createSagaMiddleware();

  const middlewares = [
    SearchHistoryMiddleware,
    OverlayMiddleware,
    dynamicMiddlewares,
    SagaMiddleware
  ];

  const store = configureStore({
    devTools: true,
    reducer: rootReducer.reducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false
        // immutableCheck: false
      }).concat(middlewares),
    preloadedState: state
  });

  if (!!serverState)
    store.dispatch(GlobalActionCreators.updateState(serverState));

  // run sagas
  SagaManager.startSagas(SagaMiddleware);

  // enable hot module reloading for reducers
  if (module.hot) {
    module.hot.accept("../reducers", () => {
      store.replaceReducer(require("../reducers").default);
    });

    module.hot.accept("../sagas", () => {
      SagaManager.cancelSagas(store);
      require("../sagas").default.startSagas(SagaMiddleware);
    });
  }

  return store;
};
